export const ConnectOrBindLogger = {};
//# sourceMappingURL=DataLogger.js.map